import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M9.63852 15.2138C9.21283 15.3979 8.74333 15.5 8.25 15.5C6.317 15.5 4.75 13.933 4.75 12C4.75 10.067 6.317 8.5 8.25 8.5C10.183 8.5 11.5 9.75 12 12C12.5 14.25 13.817 15.5 15.75 15.5C17.683 15.5 19.25 13.933 19.25 12C19.25 10.067 17.683 8.5 15.75 8.5C15.2567 8.5 14.7872 8.60207 14.3615 8.78624" vectorEffect="non-scaling-stroke" />
	</SVG>
);
